import SearchIcon from '~/assets/icons/Search';

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
};

const Search = ({ onChange, value }: Props) => {
  return (
    <div className="relative w-full">
      <div className="absolute left-2 top-2">
        <SearchIcon />
      </div>
      <input
        className="w-full rounded-lg border border-concrete py-2 pl-12 pr-2 outline-none"
        placeholder="Search"
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default Search;
